<template>
  <div class="grid__item">
    <a :href="item.detailPageUrl" class="event-card">
      <div class="event-card__image">
        <img :src="item.detailPicture.src" :alt="item.name"/>
      </div>
      <div class="event-card__text">
        <h2><span v-html="item.name"></span></h2>
        <span
          v-for="auditory in targetAudienceValue"
          :key="auditory"
          v-html="auditory"
        />
      </div>
      <div class="event-card__note" v-html="item.duration.value"></div>
    </a>
  </div>
</template>

<script>
export default {
  name: "ListItem",
  props: {
    item: {
      type: Object,
      default() {
        return {
          id: 0,
          detailPageUrl: '',
          detailPicture: {
            src: '',
          },
          name: '',
          targetAudience: {
            value: [],
          },
          duration: {
            value: '',
          },
        };
      },
    },
  },
  computed: {
    targetAudienceValue() {
      const countItem = this.item.targetAudience.value.length;
      return this.item.targetAudience.value.map((item, index) => {
        if (countItem === index + 1) {
          return item
        }
        return `${item},&nbsp;`
      })
    }
  }
}
</script>
